import { render, staticRenderFns } from "./receiptReceInvosDerated.vue?vue&type=template&id=48a242df&"
import script from "./receiptReceInvosDerated.vue?vue&type=script&lang=js&"
export * from "./receiptReceInvosDerated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports